/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = createStore;

var _redux = require('redux');

var _middlewareClientMiddleware = require('./middleware/clientMiddleware');

var _middlewareClientMiddleware2 = _interopRequireDefault(_middlewareClientMiddleware);

var _middlewareTransitionMiddleware = require('./middleware/transitionMiddleware');

var _middlewareTransitionMiddleware2 = _interopRequireDefault(_middlewareTransitionMiddleware);

function createStore(reduxReactRouter, getRoutes, createHistory, client, data) {
	var middleware = [_middlewareClientMiddleware2['default'](client), _middlewareTransitionMiddleware2['default']];

	var finalCreateStore = undefined;

	if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
		var _require = require('redux-devtools');

		var persistState = _require.persistState;

		var DevTools = require('../containers/DevTools/DevTools');
		finalCreateStore = _redux.compose(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
	} else {
		finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
	}

	finalCreateStore = reduxReactRouter({ getRoutes: getRoutes, createHistory: createHistory })(finalCreateStore);

	var reducer = require('./modules/reducer');
	var store = finalCreateStore(reducer, data);

	if (__DEVELOPMENT__ && module.hot) {
		module.hot.accept('./modules/reducer', function () {
			store.replaceReducer(require('./modules/reducer'));
		});
	}

	return store;
}

module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/create.js
 ** module id = 716
 ** module chunks = 0
 **/